import { apiClient } from '@/api/api'

export const getImageParts = async (image_key: string) => {
  return apiClient.get(`images/get-image-parts`, {
    params: {
      image_key: image_key
    }
  })
}
